import React from "react";

type TicketSummaryProps = {
  ticket: {
    siteName: string;
    arrayName?: string | null;
    inverterName?: string | null;
    notes?: string | null;
    diagnosis_json?: Record<string, unknown> | null;
  };
};

export default function TicketSummary({ ticket }: TicketSummaryProps) {
  return (
    <section className="bg-white shadow-sm rounded-lg border border-slate-200">
      <header className="px-4 py-3 border-b border-slate-200">
        <h2 className="text-lg font-semibold text-slate-900">Summary</h2>
      </header>
      <div className="p-4 grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <SummaryRow label="Site" value={ticket.siteName} />
          <SummaryRow label="Array" value={ticket.arrayName ?? "—"} />
          <SummaryRow label="Inverter" value={ticket.inverterName ?? "—"} />
          <div>
            <div className="text-xs uppercase tracking-wide text-slate-500">Notes</div>
            <p className="mt-1 text-sm text-slate-800 whitespace-pre-wrap">
              {ticket.notes ?? "No notes yet."}
            </p>
          </div>
        </div>
        <div className="space-y-2">
          <div className="text-xs uppercase tracking-wide text-slate-500">Diagnosis JSON</div>
          <pre className="text-sm bg-slate-50 border border-slate-200 rounded-md p-3 text-slate-800 overflow-x-auto">
            {JSON.stringify(ticket.diagnosis_json ?? {}, null, 2)}
          </pre>
        </div>
      </div>
    </section>
  );
}

function SummaryRow({ label, value }: { label: string; value: string }) {
  return (
    <div>
      <div className="text-xs uppercase tracking-wide text-slate-500">{label}</div>
      <div className="text-sm text-slate-900">{value}</div>
    </div>
  );
}
